import { Component , OnInit } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { Observable } from 'rxjs';

import { fetchLoggedInUser } from '../../Store/request.actions';
import { RequestState } from '../../Store/request.reducer';

@Component({
    selector: 'app-home',
    templateUrl: './home.component.html',
    styleUrl: './home.component.scss',
    standalone: true
})
export class HomeComponent implements OnInit {
  name = '';
  userData : any;
  currentUser$: Observable<any>;
  constructor(
    private store: Store<{ request : RequestState }>
  ){
    this.store.dispatch(fetchLoggedInUser());
  }

  ngOnInit(){
    var keyToRetain = ['token', 'brokerId', 'brokerMail','brokerName'];
    var keyToRemove = [];

    for (var i = 0; i < localStorage.length; i++) {
      if (!keyToRetain.includes(localStorage.key(i))) {
        keyToRemove.push(localStorage.key(i));
      }
    }
    for (var i = 0; i < keyToRemove.length; i++) {
      localStorage.removeItem(keyToRemove[i]);
    }
    this.name = localStorage.getItem('brokerName');
    this.currentUser$ = this.store.pipe(select(state => state.request.loggedInUser));
    this.currentUser$.subscribe(loggedInUser => {
      this.userData = loggedInUser;
    })
  }
}
